// @owners { team: patients }
import { type ReduxStateShared } from '~shared/types';

export const getIsEditingOrderWithAssistant = (state: ReduxStateShared): boolean =>
  state.checkout.editOrderWithAssistant;
